<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZumPlx/tc-custom/9781250108357.jpg?1731179949593" alt="This image is the cover for the book 72 Hours"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">72 Hours
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A red-hot, pulse-pounding thrill ride by <i>USA Today</i> bestselling author Bella Jewel! </b><br/><br/>It’s all part of his sick game. A game he’s been planning for an entire decade. Now everything is perfect: One woman and one man have been selected. They used to be a couple—and they can no longer stand one another. They are the perfect victims. He doesn’t intend for the game to be easy. He wants to push them to the brink of insanity, to make his hunt real. . .<br/><br/>Lara and Noah have been captured and dumped into a massive wooded area. There’s only one rule in this fatal game: They will have 72 hours to find a way out before a sadistic serial killer begins his hunt . . .But what he never could have expected was the explosive passion that ignites between the two ex-lovers—one that makes them strong. Fierce. And determined to do whatever it takes to escape—and to survive. <br/><br/><i>72 Hours </i>by Bella Jewel is a sexy, page-turning thrill ride!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bella Jewel
      </h2>
      
      <p class="authorDescription body article"><I>USA Today</I> bestselling author <B>Bella Jewel</B> is a fun-loving Australian who lives in sunny Queensland with her two playful daughters. She’s been writing since she was fifteen and has authored a broad range of stories with wild characters ranging from bikers to pirates. When she’s not writing, Bella can be found kicking about on dirt bikes or riding horses. Bella has many more books planned for the future.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?99a85aa4